/**
 * Given a query object, adds `value` to `argument` array if it does not exist.
 * Removes `value` from `argument` if it does exist.
 *
 * @param argument
 * @param value
 * @param query
 * @returns {*}
 */
export default function handleQueryArrays(argument, value, query) {
    if (query[argument]) {
        let argument_array = query[argument].split(',').map(item => (parseInt(item)))
        if (argument_array.includes(parseInt(value))) {
            argument_array = argument_array.filter(item => (item !== parseInt(value)))
            query[argument] = argument_array
        } else {
            argument_array.push(value)
        }
        if (query[argument].length < 1) {
            delete query[argument]
        } else {
            query[argument] = argument_array.join(',')
        }
    } else {
        query[argument] = value
    }

    return query
}

/**
 *
 * @param param: string
 * @param value: string
 * @param searchParams: URLSearchParams
 * @returns {*}
 */
export const toggleSearchParams = (param, value, searchParams) => {

    if (searchParams.get(param)) {
        let argument_array = searchParams.get(param).split(',').map(item => (item.toString()))

        // Remove value from the array if it exists, add it if it doesn't.
        if (argument_array.includes(value.toString())) {
            argument_array = argument_array.filter(item => (item !== value.toString()))
            // searchParams.set(value, argument_array.toString())
        } else {
            argument_array.push(value)
        }

        // If the last item has been removed from the argument array, then delete it from searchParams entirely.
        // Otherwise, turn the array back into a string and add it.
        if (searchParams.get(param).length < 1) {
            searchParams.delete(param)
        } else {
            searchParams.set(param, argument_array.join(','))
        }
    } else {
        searchParams.set(param, value)
    }

    return searchParams
}